/** Read lat/lng from gmp-map-3d location events (click and pointer variants). */

export function readLatLngFromMapLocationEvent(
  evt: Event,
): { lat: number; lng: number } | null {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const anyEvt = evt as any;
  const pos = anyEvt.detail?.position || anyEvt.position || null;
  if (!pos || typeof pos !== "object") return null;

  const lat =
    typeof pos.lat === "number"
      ? pos.lat
      : typeof pos.Fg === "number"
        ? pos.Fg
        : null;
  const lng =
    typeof pos.lng === "number"
      ? pos.lng
      : typeof pos.Hg === "number"
        ? pos.Hg
        : null;

  if (
    lat == null ||
    lng == null ||
    !Number.isFinite(lat) ||
    !Number.isFinite(lng)
  ) {
    return null;
  }
  return { lat, lng };
}
